import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { forEach, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import Pluralize from 'pluralize';
import { getSeaLinkBasename, processPassengerType } from 'utils/helpers';
import {
  getNextUpcomingReservation,
  getUpcomingBooking,
} from 'redux/selectors/current_booking';

const View = ({ name, date, vehicles }) => {
  const upcomingBooking = useSelector(getUpcomingBooking);
  const upcomingReservation = useSelector(getNextUpcomingReservation);
  const passengerTypes = useSelector((state) => state.types.passengerTypes);
  const basename = getSeaLinkBasename();
  const passengerText = useMemo(() => {
    const passengers = [];
    const passengerDetails = processPassengerType(
      upcomingReservation.passenger_splits,
      upcomingBooking.passengers_attributes,
      passengerTypes
    );

    forEach(passengerDetails, (vaule, key) => {
      passengers.push(`${vaule.count} ${Pluralize(key, vaule.count)}`);
    });

    return passengers.join(', ');
  }, [
    upcomingReservation.passenger_splits,
    upcomingBooking.passengers_attributes,
    passengerTypes,
  ]);

  return (
    <div className="upcoming-booking rounded mb-4">
      <div className="row g-0">
        <div className="upcoming-booking__tag p-3 py-2 py-lg-3 col-lg-2 text-center">
          <div>
            <i className="fa-solid fa-tickets-perforated" />
          </div>
          <div className="px-lg-3 lh-1">Your next booking</div>
        </div>
        <div className="upcoming-booking__reference p-3 col-lg-3">
          <div>
            <a className="fw-bold" href={`bookings/${upcomingBooking.id}`}>
              Booking <span className="d-lg-none">reference:</span>{' '}
              {upcomingBooking.reference}
            </a>
          </div>
          <div>{name}</div>
        </div>
        <div className="upcoming-booking__detail p-3 pt-0 pt-lg-3 col-lg-4">
          <div>
            <div className="upcoming-booking__icon">
              <i className="fa-solid fa-calendar-days" />
            </div>
            {date}
          </div>
          <div className="d-none d-lg-flex">
            <div className="upcoming-booking__icon">
              <i className="fas fa-user-friends" />
            </div>
            <div>{passengerText}</div>
          </div>
          <div className="d-none d-lg-block">
            {isEmpty(vehicles) ? (
              <p>&nbsp;</p>
            ) : (
              vehicles.map(({ icon, text }) => (
                <div key={text}>
                  <div className="upcoming-booking__icon">
                    <i className={icon} />
                  </div>
                  {text}
                </div>
              ))
            )}
          </div>
        </div>
        <div className="upcoming-booking__links p-3 col-lg-3">
          <a
            href={`/${basename}/account/history`}
            className="btn btn-outline-secondary mb-lg-2 p-1 me-4 me-lg-0"
          >
            <span className="d-lg-none">My bookings</span>
            <span className="d-none d-lg-inline">Manage my bookings</span>
          </a>
          <a
            href={`/${basename}/account`}
            className="btn btn-outline-secondary p-1 me-4 me-lg-0"
          >
            <span className="d-lg-none">My account</span>
            <span className="d-none d-lg-inline">View my account</span>
          </a>
        </div>
      </div>
    </div>
  );
};

View.propTypes = {
  name: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  vehicles: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

export default View;
